// src/screens/DashboardScreen/index.js
import DashboardScreen from './DashboardScreen';

export default DashboardScreen;